import * as React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Navigation from "./components/navigation/navigation";
import Header from "./components/header/headerComponent";

import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

class App extends React.Component {

  public render() {
    return (
      < BrowserRouter >
        <div className="app">
          <Header />
          <div className="app-content">
            <Navigation />
          </div>
          <div className="app-footer">
            © {new Date().getFullYear()} ICB - InterConsult Bulgaria All rights reserved
          </div>
        </div>
      </BrowserRouter >
    );
  }
}

export default App;
